import { __rest } from "tslib";
import * as React from 'react';
import { css } from '@patternfly/react-styles';
import { BackgroundImage } from '../BackgroundImage';
import { Brand } from '../Brand';
import { List } from '../List';
import { Login } from './Login';
import { LoginHeader } from './LoginHeader';
import { LoginFooter } from './LoginFooter';
import { LoginMainHeader } from './LoginMainHeader';
import { LoginMainBody } from './LoginMainBody';
import { LoginMainFooter } from './LoginMainFooter';
export var LoginPage = function LoginPage(_a) {
  var _a$children = _a.children,
      children = _a$children === void 0 ? null : _a$children,
      _a$className = _a.className,
      className = _a$className === void 0 ? '' : _a$className,
      _a$brandImgSrc = _a.brandImgSrc,
      brandImgSrc = _a$brandImgSrc === void 0 ? '' : _a$brandImgSrc,
      _a$brandImgAlt = _a.brandImgAlt,
      brandImgAlt = _a$brandImgAlt === void 0 ? '' : _a$brandImgAlt,
      _a$backgroundImgSrc = _a.backgroundImgSrc,
      backgroundImgSrc = _a$backgroundImgSrc === void 0 ? '' : _a$backgroundImgSrc,
      _a$backgroundImgAlt = _a.backgroundImgAlt,
      backgroundImgAlt = _a$backgroundImgAlt === void 0 ? '' : _a$backgroundImgAlt,
      _a$footerListItems = _a.footerListItems,
      footerListItems = _a$footerListItems === void 0 ? null : _a$footerListItems,
      _a$textContent = _a.textContent,
      textContent = _a$textContent === void 0 ? '' : _a$textContent,
      footerListVariants = _a.footerListVariants,
      loginTitle = _a.loginTitle,
      loginSubtitle = _a.loginSubtitle,
      _a$signUpForAccountMe = _a.signUpForAccountMessage,
      signUpForAccountMessage = _a$signUpForAccountMe === void 0 ? null : _a$signUpForAccountMe,
      _a$forgotCredentials = _a.forgotCredentials,
      forgotCredentials = _a$forgotCredentials === void 0 ? null : _a$forgotCredentials,
      _a$socialMediaLoginCo = _a.socialMediaLoginContent,
      socialMediaLoginContent = _a$socialMediaLoginCo === void 0 ? null : _a$socialMediaLoginCo,
      props = __rest(_a, ["children", "className", "brandImgSrc", "brandImgAlt", "backgroundImgSrc", "backgroundImgAlt", "footerListItems", "textContent", "footerListVariants", "loginTitle", "loginSubtitle", "signUpForAccountMessage", "forgotCredentials", "socialMediaLoginContent"]);

  var HeaderBrand = React.createElement(React.Fragment, null, React.createElement(Brand, {
    src: brandImgSrc,
    alt: brandImgAlt
  }));
  var Header = React.createElement(LoginHeader, {
    headerBrand: HeaderBrand
  });
  var Footer = React.createElement(LoginFooter, null, React.createElement("p", null, textContent), React.createElement(List, {
    variant: footerListVariants
  }, footerListItems));
  return React.createElement(React.Fragment, null, backgroundImgSrc && React.createElement(BackgroundImage, {
    src: backgroundImgSrc,
    alt: backgroundImgAlt
  }), React.createElement(Login, Object.assign({
    header: Header,
    footer: Footer,
    className: css(className)
  }, props), React.createElement(LoginMainHeader, {
    title: loginTitle,
    subtitle: loginSubtitle
  }), React.createElement(LoginMainBody, null, children), (socialMediaLoginContent || forgotCredentials || signUpForAccountMessage) && React.createElement(LoginMainFooter, {
    socialMediaLoginContent: socialMediaLoginContent,
    forgotCredentials: forgotCredentials,
    signUpForAccountMessage: signUpForAccountMessage
  })));
};